import { AvailableTimeslot } from '../../types';

export function hasDifferentTimeSelected(
    currentTimeslot: AvailableTimeslot,
    differentTimeslot: AvailableTimeslot | null
): boolean {
    if (differentTimeslot) {
        let [differentStartHour, _] = differentTimeslot.time.split(':');
        let [currentStartHour, __] = currentTimeslot.time.split(':');
        return differentStartHour === currentStartHour;
    }

    return false;
}

export function getAvailableTimeslotsPerHour(
    // availablePhotographers: AvailablePhotographer[],
    // selectedPhotographerIndex: number
    timeslots: AvailableTimeslot[]
): Map<string, AvailableTimeslot[]> {
    // if (availablePhotographers.length < 1) {
    //     return new Map<string, AvailableTimeslot[]>();
    // }

    // let timeslots = availablePhotographers[selectedPhotographerIndex].availableTimeslots;

    if (timeslots.length < 1) {
        return new Map<string, AvailableTimeslot[]>();
    }

    return transformTimeslots(timeslots);
}

function transformTimeslots(
    availableTimeslots: AvailableTimeslot[]
): Map<string, AvailableTimeslot[]> {
    return availableTimeslots.reduce((acc, availableTimeslot) => {
        let [hour, _] = availableTimeslot.time.split(':');

        if (!acc.has(hour)) {
            acc.set(hour, [availableTimeslot]);
        } else {
            let previous = acc.get(hour);
            acc.set(hour, [...previous, availableTimeslot]);
        }

        return acc;
    }, new Map<string, AvailableTimeslot[]>());
}
